export default class Helpers {
    static statingDelay() {
        return new Promise(resolve => setTimeout(resolve, 10))
    }
}